// Social Wall

import './index.scss';
import Masonry from 'masonry-layout';

export default class SocialWall {
  constructor(root) {
    this.root = root;
    this.grid = this.root.querySelector('.list');

    this.initMasonry();
    window.app.openDataHref();
    this.loadMoreItems();
  }

  initMasonry() {
    this.msnry = new Masonry( this.grid, {
      itemSelector: '.feed-item',
      columnWidth: '.feed-item-sizer',
      gutter: '.gutter-sizer'
    });
  }

  loadMoreItems() {
    this.root.addEventListener('click', (event) => {
      let loadMoreButton = event.target.closest('.load-more-feeds');
      if (!loadMoreButton) return;

      loadMoreButton.classList.add('loading');

      let dataUrl = loadMoreButton.dataset.url;

      const formData = new FormData();
      formData.append('tx_wpsocialfeed_feedslist[nextOffset]', loadMoreButton.dataset.nextOffset);
      fetch(dataUrl, {
        method: 'POST',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Expires': '0'
        },
        body: formData
      })
        .then((response) => response.text())
        .then((html) => {
          loadMoreButton.classList.remove('loading');
          loadMoreButton.parentNode.remove();
          const parser = new DOMParser();
          let doc = parser.parseFromString(html, 'text/html');
          let items = doc.querySelectorAll('.feed-item');
          items.forEach((item) => {
            this.grid.appendChild(item);
          });
          this.msnry.appended(items);
          let moreButton = doc.querySelector('.widget__footer');
          if (moreButton) {
            this.grid.after(moreButton);
          }

          window.app.openDataHref();

        })
        .catch((error) => {
        });
    });
  }
}
